import { CallbackPipe } from "./pipes/callback.pipe";
import { CampaignDiscountPipe } from "./pipes/campaign-discount.pipe";
import { DealerWebsitePipe } from "./pipes/dealer-website.pipe";
import {
  EcomProductArrayPipe,
  EcomProductPipe,
} from "./pipes/ecom-product.pipe";
import { EncodeURIComponentPipe } from "./pipes/encode-uri-component.pipe";
import { FaqSearchPipe } from "./pipes/faq-search.pipe";
import { FilterDealerPipe } from "./pipes/filter-dealer.pipe";
import { FilterNonNullishPipe } from "./pipes/filter-non-nullish.pipe";
import { GoogleMapsLatLngLitPipe } from "./pipes/google-maps-lat-lng-lit.pipe";
import { GoogleMapsLatLngPipe } from "./pipes/google-maps-lat-lng.pipe";
import { GoogleMapsLinkPipe } from "./pipes/google-maps-link.pipe";
import { GroupTagsPipe } from "./pipes/group-tags.pipe";
import { HighlightPipe } from "./pipes/highlight.pipe";
import { MediaPipe } from "./pipes/media.pipe";
import { PricePipe } from "./pipes/price.pipe";
import { ProductAddablePipe } from "./pipes/product-addable.pipe";
import { ProductImageAltPipe } from "./pipes/product-image-alt.pipe";
import { ProductImageURLPipe } from "./pipes/product-image-url.pipe";
import { SafePipe } from "./pipes/safe.pipe";
import { TagPipe } from "./pipes/tag.pipe";
import { VehiclePipe } from "./pipes/vehicle.pipe";

export const appPipes = [
  CallbackPipe,
  DealerWebsitePipe,
  EcomProductArrayPipe,
  EcomProductPipe,
  EncodeURIComponentPipe,
  FaqSearchPipe,
  FilterDealerPipe,
  FilterDealerPipe,
  FilterNonNullishPipe,
  GoogleMapsLatLngLitPipe,
  GoogleMapsLatLngLitPipe,
  GoogleMapsLatLngPipe,
  GoogleMapsLinkPipe,
  GroupTagsPipe,
  HighlightPipe,
  HighlightPipe,
  MediaPipe,
  MediaPipe,
  PricePipe,
  CampaignDiscountPipe,
  ProductAddablePipe,
  ProductImageAltPipe,
  ProductImageURLPipe,
  SafePipe,
  TagPipe,
  TagPipe,
  VehiclePipe,
];
